import { render } from "./Hamburger.vue?vue&type=template&id=6643187c"
import script from "./Hamburger.vue?vue&type=script&lang=ts"
export * from "./Hamburger.vue?vue&type=script&lang=ts"

import "./Hamburger.vue?vue&type=style&index=0&id=6643187c&lang=scss"
script.render = render

export default script